import React, { useEffect, useState } from 'react';
import { motion, useScroll, useSpring } from "framer-motion";
import { utils } from "../../utils";
import { v4 as uuidv4 } from "uuid";
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { MainNavbar, SubFooter } from "../../components";
import { setPastOrderData, selectPastOrderData } from "../../includes/navSlice";
import { OrderStatus } from "../../includes/navSlice";
import { Modal, Button, message} from "antd";


const renderOrderStatus = (orderStatus) => {
    const statusD = {
		[OrderStatus.NEW]: "Order Confirmed",
		[OrderStatus.AT_STORE]: "Out to Pick Order",
		[OrderStatus.COURIER_PICKED_UP]: "Out to Deliver Order",
		[OrderStatus.COURIER_READY_FOR_PICKUP]: "Order Ready",
		[OrderStatus.COURIER_COMPLETED]: "Delivered",
		[OrderStatus.COURIER_ACCEPTED]: "Out to Pick Order",
		[OrderStatus.COURIER_DECLINED]: "",
		[OrderStatus.PAYMENT_DECLINED]: "",
		[OrderStatus.CANCELLED]: "Cancelled",
		[OrderStatus.PENDING]: "",
    };
	const el = statusD[OrderStatus[orderStatus]];
	return el;
};

let pastList = [];
const PastOrderScreen = ({logPage}) => {

	const { scrollYProgress } = useScroll();
	const scaleX = useSpring(scrollYProgress, {
		stiffness: 100,
		damping: 30,
		restDelta: 0.001
	});
	
    const navigate = useNavigate();  
    const location = useLocation();  
	const dispatch = useDispatch();
	const pastorderlist = useSelector(selectPastOrderData);
	const sessionemail = utils.getStorage('__el_data_email');
    const authToken = utils.getStorage('__el_data_login_token');
	const [ orders, setOrders ] = useState(pastorderlist);
	const [ view, setView ] = useState(false);
	const [ email, setEmail ] = useState(sessionemail);
	const [ pasts, setPasts ] = useState(null);
	const [ viewData, setViewData ] = useState({});
	const [ viewBody, setViewBody ] = useState("");
	
	useEffect(() => {
		setEmail(email)
		window.document.body.style.overflow = "auto";
	}, []);
	
	useEffect(() => {
		const ref = document.referrer;
    const loc = location.pathname;
		logPage(ref, loc);
	}, []);
	
	useEffect(() => {
		document.title = `Past Orders | Order Online | ErrandLocal`;
		const checkLogin = async() => {
			const sessionemail = await utils.getStorage('__el_data_email');
			const redirect = await utils.checkLogin(sessionemail);
			if((redirect && sessionemail) || redirect){
				navigate(redirect);
			}
		}
		checkLogin();
	}, []);
	
	
	useEffect(() => {
		const getParams = async () => {
			try{
				var paramsFromServer;
				if(orders === null){
					paramsFromServer = await fetchParams();
					setOrders(paramsFromServer?.orders);
					dispatch(setPastOrderData(paramsFromServer?.orders));
				}
			}catch(e){}	
		}	
		getParams();
	}, []);
	
	
	useEffect(() => 
	{
		try
		{
			if(orders)
			{				
				pastList = [];
				Object.entries(orders).forEach(entry => 
				{
					document.documentElement.scrollTop = 0;				
					const [key, val] = entry;					
					const value = val['data'];
					//const chat = val['chat'];
					
					const len = value.length;
					//let expected = 0;
					let itemamount = 0;
					let data = [];
					for(let i=0; i<len; i++){
						itemamount = parseFloat(value[0]['itemamount']) / 100;
						//expected = parseFloat(value[i]['expectedQty']);
						data[i] = "<div style='color: #201e1c; font-weight: 600; font-family: Montserrat; font-size: 16px'>"+value[i]['expectedQty']+"x - "+value[i]['productName']+"</div>";
						const addons = value[i]['productAddons'];
						for (let j = 0; j < addons.length; j++) {
						  if(j === 0){
							data[i] += "<span>- "+addons[j]+"</span>";
						  }else{
							data[i] += "<br/><span>- "+addons[j]+"</span>";
						  }	
						  if(j === addons.length - 1){
							data[i] += "<br/>";
						  }
						}
					}
										
					const state = renderOrderStatus(value[0]['status']);
					const estimatedTime = value[0]["deliveryTime"];
					const timeZone = value[0]['timeZone'];
					const storename = value[0]['storename'];
					const deliveryType = value[0]['deliveryType'];
					const storestatus = value[0]['storestatus'];
					const datetime = utils.dateToString(estimatedTime, 'date', timeZone);
					
					if(state === 'Delivered' || storestatus === 'Order Declined')
					{						
						let list = {'id': key.toLowerCase(), 'href': {id: key.toLowerCase()}, 'title': storename, 'description': datetime+'. '+deliveryType, 'fill': state === 'Delivered' ? utils.getRandomColor() : "#F7685B", 'amount': utils.amountToString(itemamount), 'state': state, 'data': data, 'label': 'm26.07,24.81a2.5,2.5 0 1 1 -5,0a2.5,2.5 0 0 1 5,0z'};
						
						//pastList.push({id: key, count: expected, amount: utils.amountToString(itemamount), datetime: datetime, storename: storename, storeaddress: storeaddress, state: state, data: data, storeinstruction: storeinstruction, estimatedTime: estimatedTime, origin: origin, destination: destination, courier: courier, courierName: courierName, deliveryType: deliveryType, chat: chat, main: value});
						
						pastList.push(list);
					}
				});
				setPasts(pastList.reverse());
			}
			
		}catch(e){}	
		// eslint-disable-next-line		
	}, [orders]);
	
	
	const fetchParams = async () => {
		try{
			const target = utils.USER_CALL+'?email='+email+'&request=pastorders';
			const header = new Headers({
				'Content-Type': 'application/json',
				'Accept': 'application/json',
				'Authorization': 'Bearer '+authToken,
			});
			const posturl = utils.BASE_URL+target; //utils.GET_URL;
			const dataToPost = "";
			const res = await utils.fetchURL(posturl, 'GET', dataToPost, header);
			const data = await res.json();
			return data;
		}catch(e) {}
		
	};
	
	const SwitchRef = (ref) => {
		navigate(ref);
	}
	
	const OpenRef = (item) => {		
		setViewData(item.listdata);
		setViewBody(`${item.listdata.state}<br/><b>Order ID:</b> <font color='blue'> ${item.listdata.id}</font><br/>...............<br/><br/>${item.listdata.data.join("<br/>")}`);
		setView(!view);
	}
	
	const ListOptions = ( listdata, index ) => {
		
		return (
		
			<div className="sc-iBYQkv gwipAY" onClick={()=> OpenRef(listdata)}>
				<div className=" flex justify-between list-card ">
					<div className="flex justify-between align-center list-card-content">
						<div className="list-icon ">
							<svg width="46" height="49" viewBox="0 0 46 49" fill="none" xmlns="http://www.w3.org/2000/svg">
								<g filter="url(#filter0_d_37786_12291)">
									<rect x="10" y="10" width="26" height="29" rx="4" fill="white"></rect>
									<path d={`${listdata.listdata?.label}`} fill={`${listdata.listdata?.fill}`}></path>
								</g>
								<defs>
									<filter id="filter0_d_37786_12291" x="0" y="0" width="46" height="49" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
										<feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
										<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix>
										<feOffset></feOffset>
										<feGaussianBlur stdDeviation="5"></feGaussianBlur>
										<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
										<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_37786_12291"></feBlend>
										<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_37786_12291" result="shape"></feBlend>
									</filter>
								</defs>
							</svg>
						</div>
						<div className="flex-column list-card-texts">
							<h4 className="color-primary list-card-heading text-left margin-top-0 margin-bottom-0 btn-danger">{`${listdata.listdata?.title}`}</h4>
							<div className="color-black text-xs margin-top-1">
								<div className="text-left">{`#${listdata.listdata?.id}. ${listdata.listdata?.description}`}</div>
							</div>
						</div>
					</div>
					<div className="flex align-center arrow-wrap">
						{listdata.listdata?.amount}
						{/*<svg width="9" height="14" viewBox="0 0 9 14" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path d="M0 12.5825L1.51406 14L9 7V7V7L1.51406 0L0 1.4175L5.96719 7L0 12.5825Z" fill="#CACACA"></path>
						</svg>*/}
					</div>
				</div>
			</div>
		)
	}
		
	if(pasts?.length > 0)
	{
		return (
			<>
			<motion.div className="pprogress-bar" style={{ scaleX }} />			
			<div className="el-global--wrapper">
				<div className="el-entry el-page--transition">
					<MainNavbar />
					<div className="el-preview container" id="el-dashboard-container">
						<div className="sc-lhlUkk kRzDDN">
							<div className="animated margin-bottom-4 flex justify-between mx-auto align-center" style={{maxWidth: 533}}>
								<div className="cus_title_wrap">
									<h2>Past Orders</h2>						
								</div>
								<div className="">
									
								</div>
							</div>							
							
							<div className="sc-cabOPr kUdOjq login-card--wrap auth-wrap elAnimated elFadeInUp text-center el-overflow--hidden slide-in-bottom" style={{maxWidth: 533, width: '100%', marginLeft: 'auto', marginRight: 'auto'}}>
								<div className="cus_back_button_wrap">
									<button type="solid" style={{display: "flow-root", marginBottom: 30}} className="cus_back_button" onClick={()=> SwitchRef('/dashboard')}>Back</button>
								</div>
								{pasts.map((listdata, index) => (
									<ListOptions listdata={listdata} index={index} key={uuidv4()} /> 
								))}
							</div>							
							
						</div>
						
					</div>
				</div>
			</div>			
			<SubFooter />
			<Modal
				open={view}
				title={viewData?.title}
				onCancel={() => setView(!view)}
				footer={[
					<Button
						key="edit"
						className="c__button"
						onClick={()=> viewData?.state === 'Delivered' ? SwitchRef(`/tip/${viewData?.id}`) : setView(!view)}
					>
						 {`${viewData?.state === 'Delivered' ? 'Tip More' : 'Close'}`}
					</Button>
				]}
			>
				<p dangerouslySetInnerHTML={{__html: viewBody}}></p>				
			</Modal>
			</>
		)

	}
	else
	{
		return (
		<>
		<motion.div className="pprogress-bar" style={{ scaleX }} />			
		<div className="el-global--wrapper">
			<div className="el-entry el-page--transition">
				<MainNavbar />
				<div className="el-preview container" id="el-dashboard-container">
					<div className="sc-lhlUkk kRzDDN">
						<div className="animated margin-bottom-4 flex justify-between mx-auto align-center c-box-width">
							<div className="cus_title_wrap">
								<h2>Past Orders</h2>						
							</div>
							<div className="">
								
							</div>
						</div>
						<div className="sc-cabOPr kUdOjq login-card--wrap auth-wrap elAnimated elFadeInUp text-center el-overflow--hidden slide-in-bottom c-box-width c-box">
							<div className="cus_back_button_wrap" style={{margin: "0px 0px"}}>
								<button type="solid" style={{display: "flow-root", marginBottom: 30}} className="cus_back_button" onClick={()=> SwitchRef('/dashboard')}>Back</button>
							</div>
							<div>
								No past order found.
							</div>
						</div>
					</div>
					
				</div>
			</div>
		</div>
		<SubFooter />
		</>
	)


	}
	
	
	
};


export default PastOrderScreen;